import { createClient } from '@supabase/supabase-js';

// Updated Supabase credentials from connected project
const SUPABASE_URL = 'https://jqonvbajbbxftdhdwikp.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Impxb252YmFqYmJ4ZnRkaGR3aWtwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTA4NDE0NDksImV4cCI6MjA2NjQxNzQ0OX0.um0ivOs_Z-HB-yuHtRDyNpexxqK8R_x_sQRsRYHed7E';

if (SUPABASE_URL == 'https://<PROJECT-ID>.supabase.co' || SUPABASE_ANON_KEY == '<ANON_KEY>') {
  throw new Error('Missing Supabase variables');
}

const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
});

console.log('Supabase: Connected to', SUPABASE_URL);

export default supabase;